exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btnAdd[data-v-21aa11d9] {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 13px;\n  line-height: 15px;\n  -webkit-text-decoration-line: underline;\n          text-decoration-line: underline;\n  color: #49A0A2;\n}\n.styleFileName[data-v-21aa11d9] {\n  font-style: normal;\n  font-weight: 300;\n  font-size: 11px;\n  line-height: 13px;\n  -webkit-text-decoration-line: underline;\n          text-decoration-line: underline;\n  color: #1B1918;\n}\n.file-option-button[data-v-21aa11d9] {\n  line-height: 13px;\n}\n.btnDelete[data-v-21aa11d9] {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 12px;\n  -webkit-text-decoration-line: underline;\n          text-decoration-line: underline;\n  color: #959595;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-21aa11d9","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/LMSGiframe/components/multipleDocumentsUpload.vue
// module id = 1550
// module chunks = 2